var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-report-of-sickness-card-button",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container"},[_c('p',{staticClass:"sub"},[_vm._v("Ik wil een")]),_c('p',{staticClass:"main"},[_vm._v("nieuw verzuim")]),_c('p',{staticClass:"sub"},[_vm._v("indienen.")])])
}]

export { render, staticRenderFns }